import { apiStore } from '../stores/api.store';
import type { RoundState } from './api.types';

function getRoundStates(): RoundState[] {
    return (apiStore.getState().round?.state ?? []) as unknown as RoundState[];
}

export function getNextState(state: RoundState): RoundState | undefined {
    const states = getRoundStates();
    const idx = states.indexOf(state);
    if (idx === -1) return undefined;
    return states[idx + 1];
}

export function getNextStateData<T extends RoundState['type']>(
    state: RoundState,
    type: T,
): Extract<RoundState, { type: T }> | undefined {
    const states = getRoundStates();
    const startIdx = states.indexOf(state);
    if (startIdx === -1) return undefined;
    return states
        .slice(startIdx + 1)
        .find((s): s is Extract<RoundState, { type: T }> => s.type === type);
}
